"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColors = exports.useStyles = exports.Provider = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Styles_1 = require("./Styles");
const context = React.createContext(null);
exports.Provider = React.memo(({ dark, theme, el, children }) => {
    const value = React.useMemo(() => Styles_1.Styles.make(theme, dark), [dark, theme]);
    const vars = React.useMemo(() => value.toCssVars(), [value]);
    React.useEffect(() => {
        if (!el)
            return;
        for (const key in vars)
            el.style.setProperty(key, vars[key]);
        return () => {
            for (const key in vars)
                el.style.removeProperty(key);
        };
    }, [el, vars]);
    const child = el
        ? children
        : React.createElement('div', {
            style: { display: 'contents', ...vars },
            children,
        });
    return React.createElement(context.Provider, { value }, child);
});
const useStyles = () => React.useContext(context);
exports.useStyles = useStyles;
const useColors = () => React.useContext(context).col;
exports.useColors = useColors;
